import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import Button from '@jetbrains/ring-ui/components/button/button';
import { useNavigate } from 'react-router';
import refreshIcon from '@jetbrains/icons/update';
import copyIcon from '@jetbrains/icons/copy';
import timeIcon from '@jetbrains/icons/time';
import analyticsIcon from '@jetbrains/icons/analytics';
import Group from '@jetbrains/ring-ui/components/group/group';
import Tooltip from '@jetbrains/ring-ui/components/tooltip/tooltip';
import classNames from 'classnames';
import { useOpenModal } from '@common/modals/hooks';
import { PageTitle } from '@common/page-layout/page-title';
import { useSynchronizePluginsStateMutation } from '@common/queries/plugins';
import iconLoaders from '@common/loaders/icon-loaders.css';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
import ConfigureCustomChannelDialog from './popups/configure-custom-channel-dialog';
import PluginsPageBody from './plugins-page-body';
import styles from './plugins-page.css';
export default function PluginsPage() {
    const navigate = useNavigate();
    const synchronizeMutation = useSynchronizePluginsStateMutation();
    const configureCustomChannel = useOpenModal(ConfigureCustomChannelDialog, {});
    const serverConfig = useServerConfigContext();
    const hasAnalyticsEnabled = serverConfig.isAnalyticsEnabled();
    const handleNavigateToAuditLogs = useCallback(() => navigate('/plugins/audit-logs'), [navigate]);
    const handleNavigateToDownloadsChart = useCallback(() => navigate('/plugins/downloads'), [navigate]);
    const handleSynchronize = () => {
        synchronizeMutation.mutate();
    };
    return (_jsxs("div", { children: [_jsx(PageTitle, { title: "Plugins", rightPanel: _jsxs(Group, { className: styles.actionButtons, children: [_jsx(Tooltip, { title: "Copy plugin repository URL", children: _jsx(Button, { icon: copyIcon, onClick: () => configureCustomChannel(), ...assignTestId('copy-plugin-repository-url-button') }) }), _jsx(Tooltip, { title: "Initiate synchronization between plugins in the object storage and the database in case you\n            notice any data inconsistency", children: _jsx(Button, { icon: refreshIcon, onClick: handleSynchronize, className: classNames({
                                    [iconLoaders.refreshIconLoader]: synchronizeMutation.isLoading
                                }) }) }), hasAnalyticsEnabled && (_jsx(Tooltip, { title: "Download statistics", children: _jsx(Button, { icon: analyticsIcon, onClick: handleNavigateToDownloadsChart }) })), _jsx(Tooltip, { title: "Change history", children: _jsx(Button, { icon: timeIcon, onClick: handleNavigateToAuditLogs, ...assignTestId('change-history-button') }) })] }) }), _jsx(PluginsPageBody, {})] }));
}
